/**
 * Chatwoot opening loading overlay
 *
 * Full-screen portal shown while the SDK loads on first support-chat open.
 */

import { OnboardingBusyOverlay } from '../../components/elements/OnboardingBusyOverlay';
import { useOnboardingChatwoot } from './OnboardingChatwootProvider';

const CHATWOOT_OPENING_MESSAGES = ['Support-Chat wird geladen…'] as const;

/**
 * Renders a loading overlay when `isOpening` is true on the Chatwoot context.
 *
 * @return {Object | null} Portal overlay or null when not opening.
 */
export function OnboardingChatwootOpeningOverlay() {
  const { isOpening } = useOnboardingChatwoot();

  return (
    <OnboardingBusyOverlay
      open={isOpening}
      showAfterMs={0}
      messages={CHATWOOT_OPENING_MESSAGES}
      ariaLabel="Support-Chat wird geladen"
    />
  );
}
